export default __webpack_public_path__ + "static/19-d9c6f6cc7b77546723dd623013b00c8e.png";